import React from 'react';
import { AddonCategoryProps } from './types';
import Select from 'components/base/select';
import useNewMealXlsContext from 'contexts/new-meal-xls.context';

const AddonCategory = ({
  children,
  addonCat,
  onClick,
  showAddon,
  isEdit,
  onEditClick,
  updateAddonCategory,
  disabled
}: AddonCategoryProps) => {
  const { baseAddonCategories } = useNewMealXlsContext();
  const categoryName = addonCat?.meal_category_selection_type?.name?.toLocaleLowerCase();
  const defaulAddonName = addonCat?.meal_default_name;

  return (
    <div className={`addon_accordion relative ${disabled ? 'text-gray-4' : ' text-gray-6'}`}>
      <div className='addon_accordion_header '>
        <div className='flex flex-col'>
          {isEdit ? (
            <div className=' gap-3 text-xs mb-2 items-center'>
              <div>
                <p className='text-xs'>Base addon category</p>
                <Select
                  small
                  hasSearch
                  //loading={loading}
                  value={addonCat.base_addon_category_id}
                  options={baseAddonCategories.map((item) => {
                    return { value: item.id, text: `${item.name} - ${item.slug}` };
                  })}
                  placeholder='Select base addon category'
                  onChange={(v) => updateAddonCategory(v, 'base_addon_category_id')}
                />
              </div>
            </div>
          ) : (
            <p className='text-sm flex items-center'>
              {addonCat?.name}
              {categoryName && (
                <span className='text-xs text-gray-8 capitalize'>({categoryName})</span>
              )}
              {defaulAddonName && (
                <span className='text-xs text-gray-8 capitalize'>({defaulAddonName})</span>
              )}
              {addonCat.hasError && <div className=' h-2 w-2  bg-red-5 rounded-full ml-2' />}
            </p>
          )}

          <div className=' flex flex-wrap gap-3 text-xs '>
            <p>
              Min Selection: <span>{addonCat.min_selection_no ?? 'N/A'}</span>
            </p>
            <p>
              Max Selection: <span>{addonCat.min_selection_no ?? 'N/A'}</span>
            </p>

            <p>
              Min Selection: <span>{addonCat.min_selection_no ?? 'N/A'}</span>
            </p>
            <p>
              Summary: <span>{addonCat.summary ?? 'N/A'}</span>
            </p>
          </div>
        </div>

        <div className='flex gap-3 items-end '>
          {!disabled && (
            <button
              className='text-xs font-medium text-blue-5 cursor-pointer'
              onClick={onEditClick}>
              {isEdit ? 'Save' : 'Edit'}
            </button>
          )}
          <button className='text-red-5 text-xs font-medium cursor-pointer' onClick={onClick}>
            {showAddon ? 'Hide addons' : 'Show addons'}
          </button>
        </div>
      </div>

      {children}
    </div>
  );
};

export default AddonCategory;
